import CreateForwardingDirectiveEntryFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepCompleted'
import { checkinEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant'
import {
  MaintenanceForwardingsCheckinEntryStepOptions,
  MaintenanceForwardingsDirectiveFromSteps,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { CheckinEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

const CheckinEntryFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.CheckinEntry>) => {
  const { control } = useFormContext<CheckinEntryValidationSchema>()

  const { checkin_entry_type: watchCheckinEntryType } = useWatch({
    control,
  })

  const EntryOptionComponent = useMemo(() => {
    if (watchCheckinEntryType) {
      const checkinEntryOption =
        checkinEntryOptions[watchCheckinEntryType as MaintenanceForwardingsCheckinEntryStepOptions]

      return checkinEntryOption.components.completed
    }

    return null
  }, [watchCheckinEntryType])

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Método de check-in"
      body={<div>{EntryOptionComponent && <EntryOptionComponent />}</div>}
    />
  )
}

export default CheckinEntryFormStepCompleted
